import Vue from 'vue'
import CToast from '../components/Toast'

let Toast = Vue.extend(CToast)
let instance
let getInstance = function(text) {
  if (!instance) {
    instance = new Toast()
    document.body.append(instance.$mount().$el)
  }
  instance.text = text
  let width = text.length + 2
  width = width > 20 ? 20 : width
  width = width < 7.6 ? 7.6 : width
  instance.width = width + 'em'
  return instance;
}
let toast = {
  success(text) {
    let toast = getInstance(text)
    toast.show = true;
  },
  cancel(text) {
    let toast = getInstance(text)
    toast.type = 'cancel'
    toast.show = true
    toast.time = 3000
  },
  warn(text) {
    let toast = getInstance(text)
    toast.type = 'warn'
    toast.show = true
    toast.time = 3000
  },
  text(text) {
    let toast = getInstance(text)
    toast.type = 'text'
    toast.show = true
  },
}

export default toast



// WEBPACK FOOTER //
// ./src/utils/toast.js